import React, { useContext } from 'react';
import Modal from '../Modal';
import { FaCheckCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { SprawneMiastoContext } from '../SprawneMiastoContext';
import { MdCheck } from 'react-icons/md';

export default function ReportedModal(props: {
    onClose: () => void;
    reportId: string | undefined;
}) {
    const Context = useContext(SprawneMiastoContext);
    const { t } = useTranslation();
    const [copied, setCopied] = React.useState(false);
    return (
        <Modal show={!!props.reportId} onClose={props.onClose} width={600} showClose={true}>
            <div className={'flex flex-col items-center py-8 px-4'}>
                <FaCheckCircle className={'text-5xl text-green-700 '} />

                <h2 className={'my-2 text-center font-medium'}>
                    {t('translation:REPORT.REPORTED.TITLE')}
                </h2>
                <span className={'text-center text-sm text-gray-500'}>
                    {t('translation:REPORT.REPORTED.REPORT_TRANSFERRED')}
                </span>
                <div className={'mt-6 w-full rounded bg-slate-500/10 p-5'}>
                    <h6 className={'mb-2 font-medium'}>
                        {t('translation:REPORT.REPORTED.QUESTION.1.TITLE')}
                    </h6>
                    <p className={'text-sm'}>
                        {t('translation:REPORT.REPORTED.QUESTION.1.CONTENT')}
                    </p>
                    <h6 className={'mb-2 mt-4 font-medium'}>
                        {t('translation:REPORT.REPORTED.QUESTION.2.TITLE')}
                    </h6>
                    {Context?.user ? (
                        <p className={'text-sm'}>
                            {t('translation:REPORT.REPORTED.QUESTION.2.CONTENT_FOR_LOGGED')}
                        </p>
                    ) : (
                        <p className={'text-sm'}>
                            {t('translation:REPORT.REPORTED.QUESTION.2.CONTENT_FOR_ANONYMOUS')}
                        </p>
                    )}
                    <button
                        onClick={async () => {
                            await navigator.clipboard.writeText(
                                `${process.env.REACT_APP_WEB_URL}track/${props.reportId}`,
                            );
                            setCopied(true);
                        }}
                        className={
                            'btn-filled bg-s mt-3 ml-auto mr-auto border-2 border-SM-yellow ring-SM-yellow/50'
                        }>
                        {copied ? (
                            <>
                                <MdCheck className={'text-2xl text-green-600'} />
                                {t('translation:REPORT.REPORTED.QUESTION.2.LINK_COPIED')}
                            </>
                        ) : (
                            t('translation:REPORT.REPORTED.QUESTION.2.COPY_LINK')
                        )}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
